jQuery(document).ready(function ($) {
  $('.step-1 .question-1 .option button').click(function () {
    $(this).closest('.option').addClass('active').siblings().removeClass('active');
    if ($('.step-1 .question-2 .first_name').val() && $('.step-1 .question-2 .last_name').val()) {
      $('.step-1 .question-3').removeClass('hide');
    }
    $('.step-1 .question-3 .year select').change();
    if ($('.step-1 .question-1 .option.active').length && $('.step-1 .question-2 .first_name').val() && $('.step-1 .question-2 .last_name').val()) {
      $('.step-1 .next-step').attr('disabled', false);
    }
  })
  if ($('.step-1 .question-3 .question-title').length) {
    $('.step-1 .question-3 .question-title').html($('.step-1 .question-3 .question-title').html().replace('%FIRSTNAME%', '<span class="first-name"></span>'));
  }

  $('.step-1 .question-3 .select .label').click(function () {
    let select = $(this).closest('.select');
    select.toggleClass('expand');
  })

  if ($('.why-subscribe .list-item .item .image-item').length > 0) {
    $('.why-subscribe .list-item .item .image-item').matchHeight();
  }
  setTimeout(function () {
    if ($('.quiz .step-4 .options h2').length > 0) {
      $('.quiz .step-4 .options h2').matchHeight();
    }
  }, 5000);

  setTimeout(function () {
    if ($('.article-content .image p span img').length > 0) {
      $('.article-content .image p span img').matchHeight();
      $('.article-content .image p span').matchHeight();
    }
  }, 1000);

  $('.form-our-subscribers.mobile .list-item').addClass('owl-carousel');
  $('.form-our-subscribers.mobile .list-item.owl-carousel').owlCarousel({
    loop: false,
    margin: 10,
    nav: true,
    responsive: {
      0: {
        items: 1
      },
      767: {
        items: 1
      },
      767.98: {
        items: 1
      }
    }
  })

  // Day field
  $(".select.day").click(function (e) {
    e.stopPropagation();
    $(".select.day>.options").stop().slideDown(100);
    $(".select.year").removeClass("expand");
    $(".select.year>.options").stop().slideUp(100);
    $(".select.month").removeClass("expand");
    $(".select.month>.options").stop().slideUp(100);
  });
  $(".select.day>.options .option").click(function () {
    $(".question .select.day .label").text(this.innerHTML);
    $(".select.day").removeClass("expand");
    $(".select.day>.options").stop().slideUp(100);
  })

  // Month field
  $(".select.month").click(function (e) {
    e.stopPropagation();
    $(".select.month>.options").stop().slideDown(100);
    $(".select.day").removeClass("expand");
    $(".select.day>.options").stop().slideUp(100);
    $(".select.year").removeClass("expand");
    $(".select.year>.options").stop().slideUp(100);
  });
  $(".select.month>.options .option").click(function () {
    $(".question .select.month .label").text(this.innerHTML);
    $(".question .select.month .label").addClass("selected");
    $(".select.month").removeClass("expand");
    $(".select.month>.options").stop().slideUp(100);

  })

  // Year field
  $(".select.year").click(function (e) {
    e.stopPropagation();
    $(".select.year>.options").stop().slideToggle(100);
    $(".select.day").removeClass("expand");
    $(".select.day>.options").stop().slideUp(100);
    $(".select.month").removeClass("expand");
    $(".select.month>.options").stop().slideUp(100);
  });
  $(".select.year>.options .option").click(function () {
    $(".question .select.year .label").text(this.innerHTML);
    $(".question .select.year .label").addClass("selected");
    $(".select.year").removeClass("expand");
    $(".select.year>.options").stop().slideUp(100);
  })

  var intervalId = window.setInterval(function () {
    $("#template-page-subscription-quiz .quiz").css("height", $(".quiz .step.active").height() + $("#template-page-subscription-quiz .page-header").height());
  }, 100);

  if ($('.page-subscription-quiz').length > 0) {
    var product = JSON.parse($('.product-json').html());
    var productSelection = JSON.parse($('.products-seletion').html());
    console.log(product);
    console.log(productSelection);
    var subscriptions = false;
    if ($('.subscriptions-json').length) {
      subscriptions = JSON.parse($('.subscriptions-json').html());
    }
    //console.log(product)
    var answer = [],
      summary = [],
      first_name = '',
      last_name = '',
      birthArray = ['-', '-', '-'],
      birthday = '';

    function getAge(date_string) {
      var dob = new Date(date_string);
      //calculate month difference from current date in time
      var month_diff = Date.now() - dob.getTime();

      //convert the calculated difference in date format
      var age_dt = new Date(month_diff);

      //extract year from date    
      var year = age_dt.getUTCFullYear();

      //now calculate the age of the user
      var age = Math.abs(year - 1970);
      return age;
    }

    if ($('.step-5 .section-subtitle').length) {
      $('.step-5 .section-subtitle').each(function () {
        $(this).html($(this).html().replace('%FIRSTNAME%', '<span class="first-name"></span>'));
      })
    }

    $('.step-1 .question-2 input').change(function () {
      if ($('.step-1 .question-1 .option.active').length && $('.step-1 .question-2 .first_name').val() && $('.step-1 .question-2 .last_name').val()) {
        first_name = $('.step-1 .question-2 .first_name').val();
        last_name = $('.step-1 .question-2 .last_name').val();
        $('.step-1 .question-3 .warning .first-name').html(first_name);
        $('.step-1 .question-3 .question-title .first-name').html(first_name);
        $('.step-1 .question-3').removeClass('hide');
      } else {
        $('.step-1 .question-3').addClass('hide');
      }
      if ($('.step-1 .question-1 .option.active').length && $('.step-1 .question-2 .first_name').val() && $('.step-1 .question-2 .last_name').val()) {
        $('.step-1 .next-step').attr('disabled', false);
      }
    })

    $('.step-1 .question-3 .select .option').click(function () {
      let select = $(this).closest('.select');
      let classSelect = select.attr('class');
      //Get day for birthdates
      birthArray[0] = '01';
      //Get month for birthdates
      if (classSelect.indexOf("month") != -1) birthArray[1] = $(this).attr('value');
      //Get day year birthdates
      if (classSelect.indexOf("year") != -1) birthArray[2] = $(this).attr('value').slice(2, 4);

      //console.log(birthArray);
      birthday = birthArray.join("-");

      select.removeClass('expand');
      select.find('select').val($(this).attr('value')).change();
    })

    $('.step-1 .question-3 select').change(function () {
      if ($('.step-1 .question-3 .year select').val() && $('.step-1 .question-3 .month select').val()) {
        let age = getAge($('.step-1 .question-3 .month select').val() + '/01/' + $('.step-1 .question-3 .year select').val());
        let age_min = $('.step-1 .question-1 .option.active').attr('age-min');
        let age_max = $('.step-1 .question-1 .option.active').attr('age-max');
        if (age < age_min || age > age_max) {
          $('.step-1 .question-3 .warning .age').html(age);
          $('.step-1 .question-3 .warning .age-min').html(age_min);
          $('.step-1 .question-3 .warning .age-max').html(age_max);
          $('.step-1 .question-3 .warning').removeClass('hide');
        } else {
          $('.step-1 .question-3 .warning').addClass('hide');
        }
      }
    })
    $('.step-1 .next-step').click(function () {
      $("html").animate({ scrollTop: 0 }, 500);
      if ($('.step-1 .question-1 .option.active').length) {
        answer[0] = $('.step-1 .question-1 .option.active').attr('value');
        summary[0] = $('.step-1 .question-1 .option.active .summary').html();
      }

      if (answer[0] && $('.step-1 .question-2 .first_name').val() && $('.step-1 .question-2 .last_name').val()) {
        $('.step-1').removeClass('active');
        $('.step-2').addClass('active');
        $('.step-progress').attr('step', 2).find('.step-number').html(2);
      }
    })

    $('.step-2 .option .select').click(function () {
      let option = $(this).closest('.option');
      option.addClass('active').siblings().removeClass('active');
      option.removeClass('disactive').siblings().addClass("disactive");
      $('.step-2 .next-step').attr('disabled', false);
    })
    $('.step-2 .next-step').click(function () {
      $("html").animate({ scrollTop: 0 }, 500);
      if ($('.step-2 .option.active').length) {
        answer[1] = $('.step-2 .option.active').attr('value');
        if (answer[1] == 3) {
          window.location.href = $('.step-1 .question-1 .option.active').attr('collection-url');
        } else {
          if (answer[1] == 2) {
            // Code when customer choose Gift subscription
            let linkGift = $('.step-2 .option.active').data('link');
            if (linkGift != '') {
              window.location.href = linkGift;
            }
          } else {
            summary[1] = 'Subscription';
            $('.step-2').removeClass('active');
            $('.step-3').addClass('active');
            $('.step-progress').attr('step', 3).find('.step-number').html(3);
          }
        }
      }
    })
    $('.step-2 .back-step').click(function () {
      $("html").animate({ scrollTop: 0 }, 500);
      $('.step-2').removeClass('active');
      $('.step-1').addClass('active');
      $('.step-progress').attr('step', 1).find('.step-number').html(1);
    })
    $('.step-2 .option .compare').click(function () {
      $('.step-2b').addClass('active');
    })
    $('.step-2b .close, .step-2b .overlay').click(function () {
      $('.step-2b').removeClass('active');
    })

    $('.step-3 .option .select').click(function () {
      let option = $(this).closest('.option');
      option.addClass('active').siblings().removeClass('active');
      option.removeClass('disactive').siblings().addClass("disactive");
      $('.step-3 .next-step').attr('disabled', false);
    })
    $('.step-3 .next-step').click(function () {
      if ($('.step-3 .option.active').length) {
        let step4Class = 'a0-' + answer[0].toLowerCase().replaceAll(' ', '-').replaceAll('|', '-');
        answer[2] = $('.step-3 .option.active').attr('value');
        summary[2] = '<p>' + $('.step-3 .option.active .option-title').html() + '</p>';
        $('.step-3').removeClass('active');
        $('.step-4').addClass('active');
        $('.step-4').attr('data-age', '');
        $('.step-4').attr('data-age', step4Class);
        $('.step-progress').attr('step', 4).find('.step-number').html(4);
        setTimeout(function () {
          $('.quiz .step-4 .options h2').matchHeight();
        }, 300)
        $('.quiz .step-4 .option').show();
        if (answer[1] == '1') {
          if (answer[2] == 'Monthly') {
            $('.quiz .step-4 .option-3').hide();
          } else if (answer[2] == 'Every Other Month') {
            $('.quiz .step-4 .option-3').hide();
            $('.quiz .step-4 .option-5').hide();
          } else if (answer[2] == 'Every Quarter') {
            $('.quiz .step-4 .option-2').hide();
            $('.quiz .step-4 .option-4').hide();
            $('.quiz .step-4 .option-5').hide();
          }
        } else if (answer[1] == '2') {
          if (answer[2] == 'Monthly') {
            $('.quiz .step-4 .option-1').hide();
            $('.quiz .step-4 .option-3').hide();
          } else if (answer[2] == 'Every Other Month') {
            $('.quiz .step-4 .option-1').hide();
            $('.quiz .step-4 .option-3').hide();
            $('.quiz .step-4 .option-5').hide();
          } else if (answer[2] == 'Every Quarter') {
            $('.quiz .step-4 .option-1').hide();
            $('.quiz .step-4 .option-2').hide();
            $('.quiz .step-4 .option-4').hide();
            $('.quiz .step-4 .option-5').hide();
          }
        }
      }
    })
    $('.step-3 .back-step').click(function () {
      $("html").animate({ scrollTop: 0 }, 500);
      $('.step-3').removeClass('active');
      $('.step-2').addClass('active');
      $('.step-progress').attr('step', 2).find('.step-number').html(2);
    })
    $('.step-4 .option .select').click(function () {
      let option = $(this).closest('.option');
      option.addClass('active').siblings().removeClass('active');
      option.removeClass('disactive').siblings().addClass("disactive");
      $('.quiz .step-4 .action .next-step').attr('disabled', false);
    })
    $('.step-4 .option .compare').click(function () {
      $('.step-4b').addClass('active');
    })
    $('.step-4b .close, .step-4b .overlay').click(function () {
      $('.step-4b').removeClass('active');
    })
    $('.step-4 .next-step').click(function () {
      $("html").animate({ scrollTop: 0 }, 500);
      var $this = $(this);

      let item_id = false;
      var sellingPlansId = product.selling_plan_groups[0].selling_plans[0].id;
      var deliveryFrequency = '';
      if ($('.step-4 .option.active').length) {
        answer[3] = $('.step-4 .option.active').attr('value');
        summary[3] = '<p>' + $('.step-4 .option.active .price')[0].outerHTML + $('.step-4 .option.active .compare-price')[0].outerHTML + '</p>';
        summary[4] = $('.step-4 .option.active .summary').html();
        //console.log(product);
        product.variants.forEach(function (item) {
          if (item['option1'] == answer[0] && item['option2'] == answer[2] && item['option3'] == answer[3]) {
            item_id = item.id;
            sellingPlansId = item.selling_plan_allocations[0].selling_plan_id;
            deliveryFrequency = item['option2'];
            //console.log(item)
          }
        })

        if (productSelection.product_selection.length > 0) {
          productSelection.product_selection.forEach(function (item) {
            if (item.age == answer[0] && item.delivery_frequency == answer[2] && item.payment_ption == answer[3]) {
              item_id = item.id;
              sellingPlansId = item.selected_selling_plan;
              deliveryFrequency = item.delivery_frequency;
              console.log(item);
            }
          })
        }
      }

      if (item_id) {
        $this.attr('disabled', true);
        let properties = {};
        // if (subscriptions) {
        //   item_id = subscriptions['original_to_hidden_variant_map'][item_id]['discount_variant_id'];
        //   properties = {
        //     'shipping_interval_unit_type': subscriptions['shipping_interval_unit_type'],
        //     'shipping_interval_frequency': subscriptions['shipping_interval_frequency'],
        //     'subscription_id': subscriptions['subscription_id'],
        //     'first_name': first_name,
        //     'last_name': last_name,
        //     'birthday': birthday
        //   }

        //   if (answer[1] == '1' && answer[2] == 'Monthly' && answer[3] == '1 Box | Pay as you go') {
        //     properties['shipping_interval_unit_type'] = 'month';
        //     properties['shipping_interval_frequency'] = 1;
        //     properties['charge_interval_unit_type'] = 'month';
        //     properties['charge_interval_frequency'] = 1;
        //   } else if (answer[1] == '1' && answer[2] == 'Monthly' && answer[3] == '3 Boxes | Prepay and Save') {
        //     properties['shipping_interval_unit_type'] = 'month';
        //     properties['shipping_interval_frequency'] = 1;
        //     properties['charge_interval_unit_type'] = 'month';
        //     properties['charge_interval_frequency'] = 3;
        //   } else if (answer[1] == '1' && answer[2] == 'Monthly' && answer[3] == '6 Boxes | Prepay and Save') {
        //     properties['shipping_interval_unit_type'] = 'month';
        //     properties['shipping_interval_frequency'] = 1;
        //     properties['charge_interval_unit_type'] = 'month';
        //     properties['charge_interval_frequency'] = 6;
        //   } else if (answer[1] == '1' && answer[2] == 'Monthly' && answer[3] == '12 Boxes | Prepay and Save') {
        //     properties['shipping_interval_unit_type'] = 'month';
        //     properties['shipping_interval_frequency'] = 1;
        //     properties['charge_interval_unit_type'] = 'month';
        //     properties['charge_interval_frequency'] = 12;
        //   } else if ((answer[1] == '2' && answer[2] == 'Monthly' && answer[3] == '3 Boxes | Prepay and Save') || (answer[1] == '2' && answer[2] == 'Monthly' && answer[3] == '6 Boxes | Prepay and Save') || (answer[1] == '2' && answer[2] == 'Monthly' && answer[3] == '12 Boxes | Prepay and Save')) {
        //     properties['shipping_interval_unit_type'] = 'month';
        //     properties['shipping_interval_frequency'] = 1;
        //     properties['charge_interval_unit_type'] = 'month';
        //     //properties['charge_interval_frequency'] = 2;
        //     properties['number_charges_until_expiration'] = 1;
        //   } else if (answer[1] == '1' && answer[2] == 'Every Other Month' && answer[3] == '1 Box | Pay as you go') {
        //     properties['shipping_interval_unit_type'] = 'month';
        //     properties['shipping_interval_frequency'] = 2;
        //     properties['charge_interval_unit_type'] = 'month';
        //     properties['charge_interval_frequency'] = 2;
        //   } else if (answer[1] == '1' && answer[2] == 'Every Other Month' && answer[3] == '3 Boxes | Prepay and Save') {
        //     properties['shipping_interval_unit_type'] = 'month';
        //     properties['shipping_interval_frequency'] = 2;
        //     properties['charge_interval_unit_type'] = 'month';
        //     properties['charge_interval_frequency'] = 6;
        //   } else if (answer[1] == '1' && answer[2] == 'Every Other Month' && answer[3] == '6 Boxes | Prepay and Save') {
        //     properties['shipping_interval_unit_type'] = 'month';
        //     properties['shipping_interval_frequency'] = 2;
        //     properties['charge_interval_unit_type'] = 'month';
        //     properties['charge_interval_frequency'] = 12;
        //   } else if (answer[1] == '2' && answer[2] == 'Every Other Month' && answer[3] == '3 Boxes | Prepay and Save') {
        //     properties['shipping_interval_unit_type'] = 'month';
        //     properties['shipping_interval_frequency'] = 1;
        //     properties['charge_interval_unit_type'] = 'month';
        //     //properties['charge_interval_frequency'] = 2;
        //     properties['number_charges_until_expiration'] = 1;
        //   } else if (answer[1] == '2' && answer[2] == 'Every Other Month' && answer[3] == '6 Boxes | Prepay and Save') {
        //     properties['shipping_interval_unit_type'] = 'month';
        //     properties['shipping_interval_frequency'] = 1;
        //     properties['charge_interval_unit_type'] = 'month';
        //     //properties['charge_interval_frequency'] = 2;
        //     properties['number_charges_until_expiration'] = 1;
        //   } else if (answer[1] == '1' && answer[2] == 'Every Quarter' && answer[3] == '1 Box | Pay as you go') {
        //     properties['shipping_interval_unit_type'] = 'month';
        //     properties['shipping_interval_frequency'] = 3;
        //     properties['charge_interval_unit_type'] = 'month';
        //     properties['charge_interval_frequency'] = 3;
        //   } else if (answer[1] == '1' && answer[2] == 'Every Quarter' && answer[3] == '4 Boxes | Prepay and Save (Qrtly Full Year)') {
        //     properties['shipping_interval_unit_type'] = 'month';
        //     properties['shipping_interval_frequency'] = 3;
        //     properties['charge_interval_unit_type'] = 'month';
        //     properties['charge_interval_frequency'] = 12;
        //   } else if (answer[1] == '2' && answer[2] == 'Every Quarter' && answer[3] == '4 Boxes | Prepay and Save (Qrtly Full Year)') {
        //     properties['shipping_interval_unit_type'] = 'month';
        //     properties['shipping_interval_frequency'] = 3;
        //     properties['charge_interval_unit_type'] = 'month';
        //     //properties['charge_interval_frequency'] = 6;
        //     properties['number_charges_until_expiration'] = 1;
        //   }
        // }
        var selling_plan = product.selling_plan_groups[0].selling_plans[0].id;
        let dataAjax = {
          items: [
            {
              "id": item_id,
              "quantity": 1,
              "selling_plan": sellingPlansId
            }
          ]
        };

        console.log(dataAjax);

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: dataAjax,
          dataType: 'json',
          success: function (cart) {
            $this.attr('disabled', false);
            $('.step-5 .col-value .q1.p').html(summary[0]);
            $('.step-5 .col-value .q2').html(summary[1]);
            // $('.step-5 .col-value .q3').html(summary[2]);
            if (deliveryFrequency != '') {
              $('.step-5 .col-value .q3').html(deliveryFrequency);
            } else {
              $('.step-5 .col-value .q3').hide();
            }
            $('.step-5 .col-value .q4').html(summary[3]);
            $('.step-5 .col-value .q5').html(summary[4]);
            $('.step-5 .first-name').html(first_name);
            Shopify.theme.jsAjaxCart.showDrawer();
            Shopify.theme.jsAjaxCart.updateView();
            $('.step-4').removeClass('active');
            $('.step-5').addClass('active');
            $('.step-progress').attr('step', 5).find('.step-number').html(5);
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.log(jqXHR.responseText);
          }
        })
      }
      return false;
    })
    $('.step-4 .back-step').click(function () {
      $("html").animate({ scrollTop: 0 }, 500);
      $('.step-4').removeClass('active');
      $('.step-3').addClass('active');
      $('.step-progress').attr('step', 3).find('.step-number').html(3);
    })

    $('.step-5 .fake-checkbox').click(function () {
      $(this).toggleClass('active');
      $('.step-5 .ajax-cart__note').attr('name', function (index, attr) {
        return attr == '' ? 'note' : '';
      });
    })
    $('.step-5 .reset').click(function () {
      $("html").animate({ scrollTop: 0 }, 500);
      first_name = '';
      last_name = '';
      $('.step-5').removeClass('active');
      $('.step-1').addClass('active');
      $('.step-progress').attr('step', 1).find('.step-number').html(1);
      $('.option').removeClass('active');
      $('.step-1 input').val('');
      $('.step-1 select').val('');
      $('.step-1 .question-3').addClass('hide');
      $('.step-1 .question-3 .warning').addClass('hide');
      $('.option').removeClass('disactive');
      $('.quiz .next-step').attr('disabled', true);
      return false;
    })
    $("p:contains('Most popular')").css("background-color", "#FF62BD");
  }
})